const getBrandByMethodId = (number) => {
  switch (number) {
    case 1:
      return 'Mastercard'
    case 2:
      return 'Visa'
    case 3:
      return 'Amex'
    case 4:
      return 'Elo'
    case 5:
      return 'Hipercard'
    default:
      return null
  }
}

export default getBrandByMethodId
